import setCount from "./setCount";
import setPrices from "./setPrices";

const setCountPrice = (num) => {
  setCount(num)
  setPrices()
}

export default setCountPrice
